<app-navbar></app-navbar><br/>
<p-tabView [(activeIndex)]="panelSeleccionado">
    <p-tabPanel header="{{ 'SHOW_ACCOUNTS' | translate}}">
       <app-show-users [suscriptions]="dispositivos" [roles]="catalogoRol"></app-show-users>
    </p-tabPanel>
    <p-tabPanel header="{{ 'ADD_ACCOUNTS' | translate}}">
        <app-add-users (salirAgregar)="volverMostrarUsuarios()" [suscriptions]="dispositivos" [roles]="catalogoRol"></app-add-users>
    </p-tabPanel>
</p-tabView>
